// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"1d56c163","478":"1af1677a","787":"bd5a8236"}[chunkId] + ".chunk.js";
};